import { render } from "./eventos.vue?vue&type=template&id=cabcc07a&scoped=true"
import script from "./eventos.vue?vue&type=script&lang=js"
export * from "./eventos.vue?vue&type=script&lang=js"

import "./eventos.vue?vue&type=style&index=0&id=cabcc07a&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabcc07a"]])

export default __exports__